
function trackConnection() {
  window.gtag("event", window.location.hostname, {
    event_category: "connect",
    event_label: window.location.hostname,
    value: window.location.pathname
  });
}

function trackPageNavigation(page) {
  window.gtag("event", page, {
    event_category: "pages",
    event_label: window.location.hostname
  });
}

export { trackConnection, trackPageNavigation };
